__turbopack_context__.v({
  "form-error": "FormStatus-module-scss-module__mqXHha__form-error",
  "form-status": "FormStatus-module-scss-module__mqXHha__form-status",
  "form-success": "FormStatus-module-scss-module__mqXHha__form-success",
});
